import { NgModule, Optional, SkipSelf } from '@angular/core';
import { HTTP_INTERCEPTORS, HttpClient } from '@angular/common/http';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { JwtModule } from '@auth0/angular-jwt';


// modules
import { SharedModule } from '@app/shared/shared.module';
import { AppRoutingModule } from '@app/app-routing.module';
import { HttpErrorsInterceptor } from './errors/http-errors.interceptor';
import { AuthInterceptorService } from './auth-interceptor.service';
import { SessionInterceptorService } from './session-interceptor.service';
import { CustomErrorPageComponent } from './components/custom-error-page/custom-error-page.component';

// components

import { environment } from 'environments/environment';
import { OktaAuth } from '@okta/okta-auth-js';
import { OktaAuthModule } from '@okta/okta-angular';

// required for AOT (ahead of time) compilation in your project
// prefix and suffix are in case a different base-href is used
export function HttpLoaderFactory(http: HttpClient): TranslateHttpLoader {
    return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}
const oktaAuth = new OktaAuth(environment.okta_config);

@NgModule({
    imports: [
        SharedModule,
        AppRoutingModule,
        TranslateModule,
        CustomErrorPageComponent,
        JwtModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient]
            }
        }),
        JwtModule.forRoot({
            config: {
                tokenGetter: function tokenGetter(): string {
                    return localStorage.getItem('access_token');
                },
                allowedDomains: ['localhost:4200'],
                disallowedRoutes: ['http://localhost:4200/login']
            }
        }),
        OktaAuthModule.forRoot({oktaAuth})
    ],
    exports: [
        AppRoutingModule,
        TranslateModule,
        JwtModule,
    ],
    providers: [
        { provide: HTTP_INTERCEPTORS, useClass: HttpErrorsInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptorService, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: SessionInterceptorService, multi: true }
    ]
})
export class CoreModule {

    constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
        if (parentModule) {
            throw new Error(
                'CoreModule is already loaded. Import it in the AppModule only');
        }
    }
}
